export default __webpack_public_path__ + "static/media/rabbit3.e417de21.gif";